"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorPanel = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var pubsub_js_1 = __importDefault(require("pubsub-js"));
var react_client_1 = require("@speechly/react-client");
var types_1 = require("../types");
var ErrorDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: border-box;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  background-color: white;\n  z-index: 51;\n  user-select: none;\n  pointer-events: all;\n  color: black;\n  display: flex;\n  box-shadow: 0 0 8px #00000040;\n  flex-direction: row;\n"], ["\n  box-sizing: border-box;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  background-color: white;\n  z-index: 51;\n  user-select: none;\n  pointer-events: all;\n  color: black;\n  display: flex;\n  box-shadow: 0 0 8px #00000040;\n  flex-direction: row;\n"])));
var ErrorLeft = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  box-sizing: border-box;\n  height: 100%;\n  width: 2rem;\n  background-color: red;\n  padding: 0.2rem 0.2rem;\n  color: #ffffff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: start;\n  font-size: 1.5rem;\n"], ["\n  box-sizing: border-box;\n  height: 100%;\n  width: 2rem;\n  background-color: red;\n  padding: 0.2rem 0.2rem;\n  color: #ffffff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: start;\n  font-size: 1.5rem;\n"])));
var ErrorRight = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background-color: white;\n  padding: 1rem 3rem 1rem 1rem;\n  overflow: auto;\n"], ["\n  background-color: white;\n  padding: 1rem 3rem 1rem 1rem;\n  overflow: auto;\n"])));
var H1 = styled_components_1.default.h1(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: 1.5rem;\n  margin: 0;\n  padding: 0 0 0.5rem 0;\n"], ["\n  font-size: 1.5rem;\n  margin: 0;\n  padding: 0 0 0.5rem 0;\n"])));
var P = styled_components_1.default.p(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0 0 0.5rem 0;\n  color: #999;\n"], ["\n  margin: 0;\n  padding: 0 0 0.5rem 0;\n  color: #999;\n"])));
var A = styled_components_1.default.a(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  color: #000;\n"], ["\n  color: #000;\n"])));
var HttpsRequired = 'HttpsRequired';
var isLocalHost = function (hostname) {
    return !!(hostname === 'localhost' ||
        hostname === '[::1]' ||
        hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/) !== null);
};
/**
 * An optional dismissable React component that renders an error message if something
 * prevents Speechly SDK from functioning. It also provides recovery instructions.
 * <ErrorPanel> responds to <PushToTalkButton> presses so it needs to exist somewhere in the component hierarchy.
 *
 * It is intented to be displayed at the lower part of the screen like so:
 * <PushToTalkButtonContainer><ErrorPanel/><PushToTalkButton/><PushToTalkButtonContainer>.
 *
 * @public
 */
var ErrorPanel = function (props) {
    var _a = react_1.useState(null), visible = _a[0], setVisible = _a[1];
    react_1.useEffect(function () {
        var subTangentClick = pubsub_js_1.default.subscribe(types_1.SpeechlyUiEvents.TangentClick, function (message, payload) {
            var _a;
            switch (payload.state) {
                case react_client_1.SpeechState.NoAudioConsent:
                case react_client_1.SpeechState.NoBrowserSupport:
                    // Provide special instructions for non-https access
                    if (((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) !== 'https:' &&
                        !isLocalHost(window.location.hostname)) {
                        setVisible(HttpsRequired);
                        break;
                    }
                    setVisible(payload.state);
                    break;
                default:
                    break;
            }
        });
        return function () {
            pubsub_js_1.default.unsubscribe(subTangentClick);
        };
    }, []);
    if (visible === null)
        return null;
    return (react_1.default.createElement(ErrorDiv, null,
        react_1.default.createElement(ErrorLeft, { onClick: function () { return setVisible(null); } }, "\u00D7"),
        visible === react_client_1.SpeechState.NoAudioConsent && (react_1.default.createElement(ErrorRight, null,
            react_1.default.createElement(H1, null, "No Mic Permission"),
            react_1.default.createElement(P, null, "To use the voice interface, please allow your web browser access the microphone and reload."),
            react_1.default.createElement(P, null,
                react_1.default.createElement(A, { href: "https://docs.speechly.com/faq/#why-do-i-get-mic-consent-denied-error-in-the-playground-why-doesnt-my-microphone-work-in-the-playground" }, "Troubleshooting"),
                "\u00A0\u00A0\u00A0\u00A0",
                react_1.default.createElement(A, { href: window.location.href }, "Reload")))),
        visible === react_client_1.SpeechState.NoBrowserSupport && (react_1.default.createElement(ErrorRight, null,
            react_1.default.createElement(H1, null, "Unsupported Browser"),
            react_1.default.createElement(P, null, "To use the voice interface, please visit this site using a supported browser."),
            react_1.default.createElement(P, null,
                react_1.default.createElement(A, { href: "https://docs.speechly.com/faq/#the-microphone-doesnt-work-on-ios-and-mobile-safari" }, "Troubleshooting")))),
        visible === HttpsRequired && (react_1.default.createElement(ErrorRight, null,
            react_1.default.createElement(H1, null, "HTTPS Required"),
            react_1.default.createElement(P, null, "To use the voice interface, please visit this site using the secure https:// protocol."),
            react_1.default.createElement(P, null,
                react_1.default.createElement(A, { href: "https://docs.speechly.com/faq/#http-unsupported" }, "Troubleshooting"),
                "\u00A0\u00A0\u00A0\u00A0",
                react_1.default.createElement(A, { href: window.location.href.replace(/^http(?!s)/, 'https') }, "Try with HTTPS"))))));
};
exports.ErrorPanel = ErrorPanel;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=ErrorPanel.js.map